var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-xs"},[_vm._v("\n    Before using the application you must first agree to our Terms &\n    Conditions.\n    "),_c('span',{staticClass:"text-primaryBlue-100 cursor-pointer",on:{"click":function($event){return _vm.$modal.show('read-terms-modal', {
                data: {},
            })}}},[_vm._v("Click here to read")]),_vm._v(".\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }